import { AiRequestMetadataInput } from "@/modules/patients/detail/progress-note/services/ch/__generated__/chCallTranscriptSummarizerQuery.graphql"
import { chCallTranscriptSummarizerQuery } from "@/modules/patients/detail/progress-note/services/ch/chCallTranscriptSummarizerQuery"
import { deCallTranscriptSummarizerQuery } from "@/modules/patients/detail/progress-note/services/de/deCallTranscriptSummarizerQuery"
import { Country } from "@/types/__generated__/union-types"

export const callTranscriptSummarizerQuery = (country: Country, aiRequestMetadata: AiRequestMetadataInput) => {
  if (country === "DE") {
    return deCallTranscriptSummarizerQuery(aiRequestMetadata)
  }
  return chCallTranscriptSummarizerQuery(aiRequestMetadata)
}
